export const faqConstants = {
  DEFAULT_PAGE: 3,

  SET_FAQ_VOTE_SUCCESS: 'SET_FAQ_VOTE_SUCCESS',
  SET_FAQ_VOTE_FAILURE: 'SET_FAQ_VOTE_FAILURE',

  SET_FAQ_LIST_SUCCESS: 'SET_FAQ_LIST_SUCCESS',
  SET_FAQ_LIST_FAILURE: 'SET_FAQ_LIST_FAILURE',

  SET_FAQ_PAGE_SUCCESS: 'SET_FAQ_PAGE_SUCCESS',
  SET_FAQ_PAGE_FAILURE: 'SET_FAQ_PAGE_FAILURE',

  SET_FAQ_SEARCH_SUCCESS: 'SET_FAQ_SEARCH_SUCCESS',
  SET_FAQ_SEARCH_FAILURE: 'SET_FAQ_SEARCH_FAILURE',

  SET_FAQ_GLOSSARY_SUCCESS: 'SET_FAQ_GLOSSARY_SUCCESS',
  SET_FAQ_GLOSSARY_FAILURE: 'SET_FAQ_GLOSSARY_FAILURE',

  SET_FAQ_TREE_LIST_SUCCESS: 'SET_FAQ_TREE_LIST_SUCCESS',
  SET_FAQ_TREE_LIST_FAILURE: 'SET_FAQ_TREE_LIST_FAILURE',

  SET_FAQ_LAST_UPDATE_SUCCESS: 'SET_FAQ_LAST_UPDATE_SUCCESS',
  SET_FAQ_LAST_UPDATE_FAILURE: 'SET_FAQ_LAST_UPDATE_FAILURE',

  SET_FAQ_RECOMMENDATION_SUCCESS: 'SET_FAQ_RECOMMENDATION_SUCCESS',
  SET_FAQ_RECOMMENDATION_FAILURE: 'SET_FAQ_RECOMMENDATION_FAILURE',
};
